import { createFileRoute } from "@tanstack/react-router";
import { AiOpsScreen } from "./-ai-ops/AiOpsScreen";

export const Route = createFileRoute("/admin/ai-ops")({
  staticData: { title: "AI operations" },
  validateSearch: (s: Record<string, unknown>): { change?: string } => (typeof s.change === "string" && s.change ? { change: s.change } : {}),
  component: AiOpsScreen,
});
